<template id="mechanic">
	<div class="page page-mechanic">
		<page-top></page-top>
		<div class="page-content">
			
			<div class="left">
				<div class="heading">MECHANINCS</div>
				<div class="nav">
					<div class="nav-item" v-for="(mechanic, i) in mechanics" v-on:click="switchCharacter(mechanic, i)">
						<div class="box">
							<img v-bind:src="mechanic.nav_img" class="bg" v-if="mechanic.nav_img">
							<div class="placeholder" v-if="!mechanic.nav_img">{{mechanic.name}}</div>
						</div>
						<div class="nav-item-bg"></div>
					</div>
				</div>
			</div>
			<div class="right">
				
				<div class="intro">
					<div class="box">
						<img v-bind:src="mechanic.img" v-if="mechanic.img">
					</div>
				</div>
				
			</div>
		
		</div>

		<page-bottom></page-bottom>

	</div>
</template>

<script>
import $ from 'jquery'
export default {
	data: function() {
		return {
			mechanic: {
				nav_img: null,
				img: null
			},
			mechanics: global.mechanics || []
		}
	},
	beforeUpdate: function() {
		var intro = $('#app .intro');
		intro.find('img').hide();
		intro.animate({
			width: 4,
		}, 400)
	},
	updated: function() {
		setTimeout(function() {
			var intro = $('#app .intro');
			
			intro.animate({
				width: 910,
			}, 400, function() {
				intro.find('img').slideDown(400);
			})
		},400)
	},
	created: function() {
		
		if (!this.mechanics.length) {
			this.axios.get('/robot/getList').then((response) => {
				this.mechanics = response.data
				this.mechanic = this.mechanics[0]
				global.mechanics = response.data
				this.switchCharacter(this.mechanics[0], 0);
			})
		} else {
			this.mechanic = this.mechanics[0]
			this.switchCharacter(this.mechanics[0], 0);
		}
	},
	mounted: function() {

	},
	methods: {
		switchCharacter: function(mechanic, i) {

			if (!mechanic.img) {
				return;
			}
			this.mechanic = mechanic;
			$('#app .nav-item.active').removeClass('active');
			$('#app .nav-item').eq(i).addClass('active');
			
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Mechanic.vue